/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Android_AppInputs */

const en_common_android_app = /** @type {(inputs: Common_Android_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android App`)
};

const es_common_android_app = /** @type {(inputs: Common_Android_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App para Android`)
};

/**
* | output |
* | --- |
* | "Android App" |
*
* @param {Common_Android_AppInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_android_app = /** @type {((inputs?: Common_Android_AppInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Android_AppInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_android_app(inputs)
	return en_common_android_app(inputs)
});